export default "__VITE_ASSET__5a91d1fa__"